import React, { useReducer } from 'react';
import apiJavabikes from "../../config/axios";


import ProductosContext from './productosContext';
import ProductosReducer from './productosReducer';
import { useNavigate } from 'react-router-dom';
import {
    OBTENER_PRODUCTOS,
    OBTENER_PRODUCTO,
    ADD_CART,
    REMOVE_CART,
    CREAR_PRODUCTO,
    OBTENER_ORDENES,
    CREAR_ORDENES,
    OBTENER_CARRITO,
    OBTENER_ORDEN
} from '../../types';
import axios from 'axios';

const ProductosState = props => {

    const initialState = {
        productos: [],
        producto: null,
        cart: [],
        ordenes: [],
        orden: null
    }

    const [state, dispatch] = useReducer(ProductosReducer, initialState);


    const getProductos = async () => {
        try {
            const respuesta = await apiJavabikes.get('/productos');
            dispatch({
                type: OBTENER_PRODUCTOS,
                payload: respuesta.data.productos
            })
        } catch (error) {
            console.log(error);
        }
    }

    const getProducto = async id => {
        try {
            const respuesta = await apiJavabikes.get(`/productos/${id}`);
            dispatch({
                type: OBTENER_PRODUCTO,
                payload: respuesta.data.producto
            })
        } catch (error) {
            console.log(error);
        }
    }

    const getCart = async () => {
        try {
            let ip = '0.0.0.0'; // Valor por defecto
            try {
                console.log(localStorage.getItem('user_ip'))
                if (localStorage.getItem('user_ip')){
                    ip = localStorage.getItem("user_ip")
                    console.log(ip)
                }
                else{
                    const { ip: fetchedIp } = (await axios.get("https://api.ipify.org?format=json")).data;
                    ip = fetchedIp;
                    localStorage.setItem("user_ip", ip);
                    console.log(ip)
                }
                
            } catch (ipError) {
                console.warn('No se pudo obtener la IP:', ipError);
            }

            const respuesta = await apiJavabikes.get('/carrito', { params: { ip } });

            dispatch({
                type: OBTENER_CARRITO,
                payload: respuesta.data.productosCarrito
            });

        } catch (error) {
            console.error('Error al obtener el carrito:', error);
        }
    }


    const postProducto = async (producto) => {
        try {
            const respuesta = await apiJavabikes.post('/productos', producto);
            dispatch({
                type: CREAR_PRODUCTO,
                payload: respuesta.data.producto
            })

        } catch (error) {
            console.log(error);
        }
    }

    const putProducto = async (id, producto) => {
        try {
            const res = await apiJavabikes.put(`/productos/${id}`, producto);
            return res.data;
        } catch (error) {
            console.log(error);
        }
    }
    
    const deleteProducto = async (id) => {
        try {
            const res = await apiJavabikes.delete(`/productos/${id}`);
            return res.data;
        } catch (error) {
            console.log(error);
        }
    }

    const addCart = async (producto, stat) => {
        try {
            const res = await apiJavabikes.post('/carrito', {...producto});

          
            dispatch({
                type: ADD_CART,
                payload: res.data.producto
            })

            return res.data;
        } catch (error) {
            console.log(error);
        }
    }

    const removeCart = async (id, id_usuario, size, color) => {
        try {
            let ip = '0.0.0.0'; // Valor por defecto
            try {
                if (localStorage.getItem('user_ip')){
                    ip = localStorage.getItem("user_ip")
                }
                else { 
                    const { ip: fetchedIp } = (await axios.get("https://api.ipify.org?format=json")).data;
                    ip = fetchedIp;
                }
                
            } catch (ipError) {
                console.warn('No se pudo obtener la IP:', ipError);
            }
            const res = await apiJavabikes.delete(`/carrito/${id}/${ip}`, { data: { size, color }});
            dispatch({
                type: REMOVE_CART,
                payload: { id, size, color }
            })
        } catch (error) {

        }

    }

    const getOrdenes = async () => {
        try {
            const respuesta = await apiJavabikes.get('/ordenes');
            dispatch({
                type: OBTENER_ORDENES,
                payload: respuesta.data.ordenes
            })
        } catch (error) {
            console.log(error);
        }
    }

    const getOrden = async (norden) => {
        try {
            const respuesta = await apiJavabikes.get(`/orders/${norden}`);
            dispatch({
                type: OBTENER_ORDEN,
                payload: respuesta.data.data
            })
        } catch (error) {
            console.log(error);
        }
    }

    const postOrdenes = async (orderData) => {
        try {

            

            // Validamos campos requeridos para delivery
            if (orderData.deliveryMethod === 'delivery' && 
                (!orderData.address || !orderData.city || !orderData.postalCode)) {
                throw new Error('Faltan campos requeridos para envío a domicilio');
            }

            // Enviar directamente los datos al backend
            const respuesta = await apiJavabikes.post('/orders', orderData);
            
            if (respuesta.data && respuesta.data.id) {
                dispatch({
                    type: CREAR_ORDENES,
                    payload: respuesta.data
                });
            }

            return respuesta.data;
        } catch (error) {
            console.error('Error al crear la orden:', error);
            throw error;
        }
    }

    return (
        <ProductosContext.Provider
            value={{
                productos: state.productos,
                producto: state.producto,
                cart: state.cart,
                ordenes: state.ordenes,
                orden: state.orden,
                getOrdenes,
                getOrden,
                postOrdenes,
                getProductos,
                getProducto,
                postProducto,
                putProducto,
                deleteProducto,
                addCart,
                getCart,
                removeCart
            }}
        >
            {props.children}
        </ProductosContext.Provider>
    )
}

export default ProductosState;